import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { COLUMNS_TO_SHOW_WEB, FILTER_CONFIG_FIELDS, TABLE_CONFIG_COLUMNS } from './crud-config';
import { ITransaction, ITransactionFilters, MerchantTransactionsService } from './merchant-transactions.service';
import { AbstractCrudCES } from '../../../../../shared/components/crud/abstract-crud-ces';

@Component({
    selector: 'app-merchant-transactions',
    templateUrl: './merchant-transactions.component.html',
    styleUrls: ['./merchant-transactions.component.sass'],
})
export class MerchantTransactionsComponent extends AbstractCrudCES<ITransaction> implements OnInit {
    transactions: ITransaction[] = [];
    dataSource: MatTableDataSource<ITransaction> = new MatTableDataSource<ITransaction>([]);
    merchantName: string = '';

    override config = FILTER_CONFIG_FIELDS;
    configColumns = TABLE_CONFIG_COLUMNS;
    displayedColumns = COLUMNS_TO_SHOW_WEB;

    constructor(
        fb: FormBuilder,
        private dialogRef: MatDialogRef<MerchantTransactionsComponent>,
        private transactionsService: MerchantTransactionsService,
        private toastService: ToastService,
        @Inject(MAT_DIALOG_DATA) public override data: any
    ) {
        super(fb);
        this.merchantName = this.data?.merchantName || 'Comerciante';
    }

    override ngOnInit(): void {
        super.ngOnInit();

        const today = new Date();

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const twoDaysAgo = new Date(today);
        twoDaysAgo.setDate(today.getDate() - 2);

        this.form.patchValue({
            startDate: this.formatDateForInput(twoDaysAgo),
            endDate: this.formatDateForInput(tomorrow),
            tipoDataPesquisa: 0
        });
    }

    private formatDateForInput(date: Date): string {
        return date.toISOString().split('T')[0];
    }

    loadTransactions(): void {
        if (this.form.invalid || !this.data?.canviId) {
            this.toastService.showError('Dados inválidos para buscar transações');
            return;
        }

        const formValue = this.form.value;

        const filters: ITransactionFilters = {
            startDate: formValue.startDate,
            endDate: formValue.endDate,
            dateType: formValue.tipoDataPesquisa,
            accountId: this.data.canviId,
            cnpjNumber: this.data.documentNumber
        };

        this.transactionsService.getTransactions(filters)
            .pipe(
                catchError(error => {
                    console.error('Erro ao carregar transações:', error);
                    this.toastService.showError('Erro ao carregar transações do comerciante');
                    return of([]);
                }),
            )
            .subscribe(transactions => {
                this.transactions = transactions;
                this.dataSource.data = transactions;
                if (transactions.length === 0) {
                    this.toastService.showInfo('Nenhuma transação encontrada para o período selecionado');
                }
            });
    }

    onClose(): void {
        this.dialogRef.close();
    }

    getTipoDataPesquisaLabel(): string {
        const tipo = this.form.get('tipoDataPesquisa')?.value;
        return tipo === 0 ? 'Criação' : 'Baixa';
    }

    formatCurrency(value: number): string {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    }

    public formatDate(dateString: string): string {
        return new Date(dateString).toLocaleDateString('pt-BR');
    }
}
